var mixins = {
	data: () => {
		return {
			/**
			 * Lista de objetos que deve ser paginado
			 */
			infoItems: [],
			/**
			 * Index inicial da lista que esta sendo exibida
			 */
			atualStartIndex: 0,
			/**
			 * Index final da lista que esta sendo exibida
			 */
			atualEndIndex: 0,
			/**
			 * Quantidade de itens por pagina
			 */
			quantityPerPage: 0,
		}
	},
	methods: {
		/**
		 * Seta o Indice inicial e final
		 * @param {Indice Inicial} startIndex
		 */
		setStartEnd(startIndex) {
			this.atualStartIndex = startIndex
			this.atualEndIndex = startIndex + this.quantityPerPage
		},
		/**
		 * Seta a quantidade de objetos por pagina
		 * @param {Quantidade por pagina} quantityPerPage
		 */
		setQuantityPerPage(quantityPerPage) {
			this.quantityPerPage = quantityPerPage
		},
	},
}

export default mixins
